import { useEffect, useRef } from "react";

// USAGE: const elRef = useHorizontalScroll("mode")
// <element ref={elRef}/>

export function useHorizontalScroll(mode = "normal") {
  const elRef = useRef();
  useEffect(() => {
    const el = elRef.current;
    if (el) {
      const onWheel = (e) => {
        if (e.deltaY == 0 || e.deltaX) return;
        e.preventDefault();
        el.scrollTo({
          left:
            mode === "faster"
              ? el.scrollLeft + e.deltaY + e.deltaY
              : el.scrollLeft + e.deltaY,
          behavior: "smooth",
        });
      };
      el.addEventListener("wheel", onWheel);
      return () => el.removeEventListener("wheel", onWheel);
    }
  }, []);
  return elRef;
}
